import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import LoadingPage from './LoadingPage';

const ProtectedRoute = ({ children }) => {
    const [loading, setLoading] = useState(true); // State to track loading
    const [isAuthenticated, setIsAuthenticated] = useState(false); // State to track authentication status

    useEffect(() => {
        const checkSession = () => {
            const jwtToken = localStorage.getItem('jwtToken'); // Get jwtToken from localStorage
            if (jwtToken) {
                setIsAuthenticated(true); // Set authenticated if token exists
            }
            setLoading(false); // Stop loading after checking token
        };

        checkSession();
    }, []);

    if (loading) {
        return <LoadingPage />; // Show the loading page if it's still loading
    }

    return isAuthenticated ? children : <Navigate to="/login" />; // Redirect to login page if not authenticated
};

export default ProtectedRoute;
